<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputMobileNumber" });
import { Input } from "../../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
const NUMBER_MAX_LENGTH = 15;
const NUMBER_MIN_LENGTH = 5;
let number = value === void 0 ? "" : value;
const onNumberChange = (number2) => {
    if (typeof number2 !== "string") {
        value = void 0;
        return;
    }
    if (number2 === "") {
        value = void 0;
        return;
    }
    value = number2.replace(/\D/gu, "").replace(/^0+/gu, "");
};
const onValueChange = (value2) => {
    number = value2 === void 0 ? void 0 : value2;
};
$: onNumberChange(number);
$: onValueChange(value);
</script>

<Input
    bind:value = { number }
    autocomplete = 'tel-national'
    keyboard = 'tel'
    label = 'resource.user.properties.mobile.label'
    maxLength = { NUMBER_MAX_LENGTH }
    minLength = { NUMBER_MIN_LENGTH }
    name = 'user.mobile.number'
    pattern = '^([0-9\.\/\-\(\)#\*\+]*)$'
    placeholder = 'resource.user.properties.mobile.label'
    type = 'tel'
    { isDisabled }
    { isReadonly }
    { isRequired }
/>